import React, { ComponentType, ElementType, SVGProps, useEffect, useState } from 'react';
import cx from 'classnames';

import styles from './SvgAnimationBox.scss';

const animationStartTime = 700;

type SvgExtraProps = {
  activate: boolean;
  animationId: string;
  repeatTime?: string;
  startTime?: string;
};

type SvgAnimationBoxProps = {
  animate: boolean;
  className?: string;
  elem?: ElementType;
  hiddenClassName?: string;
  id: string;
  repeatTime?: string;
  showSvg?: boolean;
  startTime?: string;
  svg: ComponentType<SVGProps<SVGSVGElement> & SvgExtraProps>;
}

export const SvgAnimationBox = (
  {
    animate = false,
    className = '',
    elem: Elem = 'div',
    hiddenClassName = '',
    id,
    repeatTime,
    showSvg = true,
    startTime,
    svg: Svg,
  }: SvgAnimationBoxProps,
) => {
  const [start, setStart] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setStart(animate);
    let timeOut: ReturnType<typeof setTimeout> | undefined;
    if (animate && loaded) {
      // Starting animation by click, due to Chrome behavior.
      // Chrome does not trigger animation start when returning to this animation multiple times.
      timeOut = setTimeout(() => {
        document.getElementById(id)?.dispatchEvent?.(new Event('click'));
      }, animationStartTime);
    }
    return () => {
      if (timeOut) {
        clearTimeout(timeOut);
      }
    };
  }, [animate, id, loaded]);

  return (
    <Elem
      className={cx(styles.box, className, {
        [styles.loading]: !loaded,
        [hiddenClassName]: !loaded && !!hiddenClassName,
      })}
    >
      {showSvg && (
        <Svg
          activate={start}
          animationId={id}
          onLoad={() => setLoaded(true)}
          repeatTime={repeatTime}
          startTime={startTime}
        />
      )}
    </Elem>
  );
};
